import { useTheme } from '../arrangement/ThemeContext';

export function ThemeToggle({ compact = false }) {
  const { theme, toggleTheme } = useTheme();

  if (compact) {
    // Compact version for mobile menu
    return (
      <div 
        onClick={toggleTheme}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0.75rem',
          borderRadius: '0.5rem',
          backgroundColor: 'rgba(0, 212, 170, 0.05)',
          border: '1px solid rgba(0, 212, 170, 0.2)',
          cursor: 'pointer',
          transition: 'background-color 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(0, 212, 170, 0.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(0, 212, 170, 0.05)';
        }}
      >
        <span style={{
          color: '#ccc',
          fontSize: '0.875rem',
          fontWeight: '500'
        }}>
          Theme
        </span>
        
        <div style={{
          width: '3rem',
          height: '1.5rem',
          backgroundColor: theme === 'dark' ? '#2c3e50' : '#87CEEB',
          borderRadius: '0.75rem',
          position: 'relative',
          transition: 'background-color 0.3s ease',
          boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.2)'
        }}>
          {/* Stars for dark mode */}
          {theme === 'dark' && (
            <>
              <div style={{
                position: 'absolute',
                width: '2px',
                height: '2px',
                backgroundColor: '#fff',
                borderRadius: '50%',
                top: '4px',
                left: '18px',
                opacity: 0.8
              }} />
              <div style={{
                position: 'absolute',
                width: '1.5px',
                height: '1.5px',
                backgroundColor: '#fff',
                borderRadius: '50%',
                top: '10px',
                left: '22px',
                opacity: 0.6
              }} />
            </>
          )}

          {/* Cloud for light mode */}
          {theme === 'light' && (
            <div style={{
              position: 'absolute',
              right: '28px',
              top: '5px',
              width: '8px',
              height: '4px',
              backgroundColor: '#fff',
              borderRadius: '4px',
              opacity: 0.8
            }}>
              <div style={{
                position: 'absolute',
                width: '4px',
                height: '4px',
                backgroundColor: '#fff',
                borderRadius: '50%',
                top: '-2px',
                left: '1px'
              }} />
            </div>
          )}

          {/* Toggle circle */}
          <div style={{
            position: 'absolute',
            width: '1.25rem',
            height: '1.25rem',
            backgroundColor: theme === 'dark' ? '#f4f4f4' : '#FFD700',
            borderRadius: '50%',
            top: '0.125rem',
            left: theme === 'dark' ? '0.125rem' : '1.625rem',
            transition: 'left 0.3s ease, background-color 0.3s ease',
            boxShadow: theme === 'dark' 
              ? '0 1px 2px rgba(0, 0, 0, 0.3)' 
              : '0 1px 3px rgba(255, 215, 0, 0.4)'
          }}>
            {/* Moon craters */}
            {theme === 'dark' && (
              <>
                <div style={{
                  position: 'absolute',
                  width: '3px',
                  height: '3px',
                  backgroundColor: '#d4d4d4',
                  borderRadius: '50%',
                  top: '4px',
                  left: '5px'
                }} />
                <div style={{
                  position: 'absolute',
                  width: '2px',
                  height: '2px',
                  backgroundColor: '#d4d4d4',
                  borderRadius: '50%',
                  top: '8px',
                  left: '7px'
                }} />
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Original full-size desktop version
  return (
    <div 
      onClick={toggleTheme}
      style={{
        position: 'fixed',
        width: '3.75rem',
        height: '1.875rem',
        backgroundColor: theme === 'dark' ? '#2c3e50' : '#87CEEB',
        borderRadius: '0.9375rem',
        top: '1rem',
        cursor: 'pointer',
        left: '1.2rem',
        transition: 'background-color 0.3s ease',
        boxShadow: 'inset 0 0.125rem 0.25rem rgba(0, 0, 0, 0.2)',
        overflow: 'hidden',
        display: window.innerWidth <= 768 ? 'none' : 'block'
      }}
    >
      {/* Stars for dark mode */}
      {theme === 'dark' && (
        <>
          <div style={{
            position: 'absolute',
            width: '0.1875rem',
            height: '0.1875rem',
            backgroundColor: '#fff',
            borderRadius: '50%',
            top: '0.5rem',
            left: '2.1875rem',
            opacity: 0.8
          }} />
          <div style={{
            position: 'absolute',
            width: '0.125rem',
            height: '0.125rem',
            backgroundColor: '#fff',
            borderRadius: '50%',
            top: '0.9375rem',
            left: '2.625rem',
            opacity: 0.6
          }} />
          <div style={{
            position: 'absolute',
            width: '0.125rem',
            height: '0.125rem',
            backgroundColor: '#fff',
            borderRadius: '50%',
            top: '1.25rem',
            left: '2.375rem',
            opacity: 0.7
          }} />
        </>
      )}

      {/* Cloud for light mode */}
      {theme === 'light' && (
        <div style={{
          position: 'absolute',
          right: '2.375rem',
          top: '0.625rem',
          width: '0.75rem',
          height: '0.3125rem',
          backgroundColor: '#fff',
          borderRadius: '0.625rem',
          opacity: 0.8
        }}>
          <div style={{
            position: 'absolute',
            width: '0.375rem',
            height: '0.375rem',
            backgroundColor: '#fff',
            borderRadius: '50%',
            top: '-0.1875rem',
            left: '0.125rem'
          }} />
        </div>
      )}

      {/* Toggle circle (Moon/Sun) */}
      <div style={{
        position: 'absolute',
        width: '1.625rem',
        height: '1.625rem',
        backgroundColor: theme === 'dark' ? '#f4f4f4' : '#FFD700',
        borderRadius: '50%',
        top: '0.125rem',
        left: theme === 'dark' ? '0.125rem' : '2rem',
        transition: 'left 0.3s ease, background-color 0.3s ease',
        boxShadow: theme === 'dark' 
          ? '0 0.125rem 0.25rem rgba(0, 0, 0, 0.3)' 
          : '0 0.125rem 0.375rem rgba(255, 215, 0, 0.4), 0 0 0.625rem rgba(255, 215, 0, 0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {/* Moon craters */}
        {theme === 'dark' && (
          <>
            <div style={{
              position: 'absolute',
              width: '0.25rem',
              height: '0.25rem',
              backgroundColor: '#d4d4d4',
              borderRadius: '50%',
              top: '0.4375rem',
              left: '0.5rem'
            }} />
            <div style={{
              position: 'absolute',
              width: '0.1875rem',
              height: '0.1875rem',
              backgroundColor: '#d4d4d4',
              borderRadius: '50%',
              top: '0.875rem',
              left: '0.75rem'
            }} />
          </>
        )}
        
        {/* Sun rays */}
        {theme === 'light' && (
          <>
            {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
              <div
                key={i}
                style={{
                  position: 'absolute',
                  width: '0.125rem',
                  height: '0.25rem',
                  backgroundColor: '#FFD700',
                  borderRadius: '0.0625rem',
                  top: '50%',
                  left: '50%',
                  transform: `translate(-50%, -50%) rotate(${angle}deg) translateY(-0.875rem)`,
                  opacity: 0.6
                }}
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
}